"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIdentityValue = void 0;
var account_api_1 = require("@newfront-insurance/account-api");
var class_validator_1 = require("class-validator");
var driver_license_validator_1 = require("driver-license-validator");
var formatters_1 = require("../formatters");
var business_identifier_1 = require("./regexes/business-identifier");
var permanent_resident_card_1 = require("./regexes/permanent-resident-card");
var ssn_1 = require("./regexes/ssn");
function isIdentityValue(identity) {
    var type = identity.type, countryCode = identity.countryCode, value = identity.value, issuingState = identity.issuingState;
    if (!type || !countryCode || !value || (typeof value !== 'string' && typeof value !== 'number')) {
        return false;
    }
    var cleanValue = (0, formatters_1.toAlphaNumeric)(value);
    switch (type) {
        case account_api_1.IdentityType.BUSINESS_IDENTIFIER: {
            var regex = business_identifier_1.BUSINESS_IDENTIFIERS_REGEXES.get(countryCode);
            return regex ? !!cleanValue.match(regex) : !!cleanValue;
        }
        case account_api_1.IdentityType.PASSPORT: {
            return (0, class_validator_1.isPassportNumber)(cleanValue, countryCode);
        }
        case account_api_1.IdentityType.SSN: {
            return countryCode === 'US' && !!cleanValue.match(ssn_1.SSN_REGEX);
        }
        case account_api_1.IdentityType.DRIVERS_LICENSE: {
            return !!issuingState && (0, driver_license_validator_1.isValid)(cleanValue);
        }
        case account_api_1.IdentityType.PERMANENT_RESIDENT_CARD: {
            return countryCode === 'US' && !!cleanValue.match(permanent_resident_card_1.PERMANENT_RESIDENT_CARD_REGEX);
        }
        default: {
            return true;
        }
    }
}
exports.isIdentityValue = isIdentityValue;
//# sourceMappingURL=is-identity-value.js.map